module.exports = __webpack_public_path__ + "static/pic02.5515b55f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic02.jpg
// module id = 529
// module chunks = 35783957827783